import { Injectable } from "@angular/core";

import {
    MSSQL,
    MySQL,
    PostgreSQL,
    StandardSQL,
    SQLDialect,
    SQLDialectSpec,
} from "@codemirror/lang-sql";

import { SqlDialectType, } from "../models";


@Injectable()
export class SqlEditorLanguageDialectService {

    public getSqlDialect(dialect: string, spec?: SQLDialectSpec): SQLDialect {
        const base: SQLDialect = this.getSqlDialectFromName(dialect);

        if (!spec) return base;

        return SQLDialect.define({ ...base.spec, ...spec })
    }

    public getSqlDialectFromName(dialect: string): SQLDialect {
        switch (dialect) {
            case SqlDialectType.StandardSQL:
                return StandardSQL;
            case SqlDialectType.PostgresSQL:
                return PostgreSQL;
            case SqlDialectType.MySQL:
                return MySQL;
            case SqlDialectType.MSSQL:
                return MSSQL;
        }
        return StandardSQL;
    }
}